/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Feedback } from '../model/feedback';
import { FeedbackPagination } from '../model/feedbackPagination';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { FeedbackServiceInterface }                            from './feedback.serviceInterface';


@Injectable()
export class FeedbackService implements FeedbackServiceInterface {

    protected basePath = 'https://api.keyclic.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve all Feedback resources.
     * 
     * @param x_keyclic_app 
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param state 
     * @param category The identifier of the resource formatted as GUID string.
     * @param geo_near One latitude, one longitude and one radius (in meters) serialized and separated by a plus or a minus sign.
     * @param geo_hash 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param visibility 
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetFeedback(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, state?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe?: 'body', reportProgress?: boolean): Observable<FeedbackPagination>;
    public cgetFeedback(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, state?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FeedbackPagination>>;
    public cgetFeedback(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, state?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FeedbackPagination>>;
    public cgetFeedback(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, state?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetFeedback.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (category !== undefined && category !== null) {
            queryParameters = queryParameters.set('category', <any>category);
        }
        if (geo_near !== undefined && geo_near !== null) {
            queryParameters = queryParameters.set('geo_near', <any>geo_near);
        }
        if (geo_hash !== undefined && geo_hash !== null) {
            queryParameters = queryParameters.set('geo_hash[]', <any>geo_hash);
        }
        if (organization !== undefined && organization !== null) {
            queryParameters = queryParameters.set('organization', <any>organization);
        }
        if (visibility !== undefined && visibility !== null) {
            queryParameters = queryParameters.set('visibility[]', <any>visibility);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<FeedbackPagination>(`${this.basePath}/feedbacks`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve all Feedback resources.
     * 
     * @param x_keyclic_app 
     * @param person The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param category The identifier of the resource formatted as GUID string.
     * @param geo_near One latitude, one longitude and one radius (in meters) serialized and separated by a plus or a minus sign.
     * @param geo_hash 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param state 
     * @param visibility 
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetFeedbackByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, state?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe?: 'body', reportProgress?: boolean): Observable<FeedbackPagination>;
    public cgetFeedbackByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, state?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FeedbackPagination>>;
    public cgetFeedbackByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, state?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FeedbackPagination>>;
    public cgetFeedbackByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, category?: string, geo_near?: '^[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+[+]\\d*\\.?\\d+' | '[-+]?\\d*\\.?\\d+[-+]\\d*\\.?\\d+' | '[+]?\\d*\\.?\\d+', geo_hash?: string, organization?: string, state?: string, visibility?: 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE', page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetFeedbackByPerson.');
        }
        if (person === null || person === undefined) {
            throw new Error('Required parameter person was null or undefined when calling cgetFeedbackByPerson.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (category !== undefined && category !== null) {
            queryParameters = queryParameters.set('category', <any>category);
        }
        if (geo_near !== undefined && geo_near !== null) {
            queryParameters = queryParameters.set('geo_near', <any>geo_near);
        }
        if (geo_hash !== undefined && geo_hash !== null) {
            queryParameters = queryParameters.set('geo_hash[]', <any>geo_hash);
        }
        if (organization !== undefined && organization !== null) {
            queryParameters = queryParameters.set('organization', <any>organization);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (visibility !== undefined && visibility !== null) {
            queryParameters = queryParameters.set('visibility[]', <any>visibility);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<FeedbackPagination>(`${this.basePath}/people/${encodeURIComponent(String(person))}/feedbacks`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve one Feedback resource.
     * 
     * @param x_keyclic_app 
     * @param feedback The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFeedback(x_keyclic_app: string, feedback: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Feedback>;
    public getFeedback(x_keyclic_app: string, feedback: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Feedback>>;
    public getFeedback(x_keyclic_app: string, feedback: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Feedback>>;
    public getFeedback(x_keyclic_app: string, feedback: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling getFeedback.');
        }
        if (feedback === null || feedback === undefined) {
            throw new Error('Required parameter feedback was null or undefined when calling getFeedback.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<Feedback>(`${this.basePath}/feedbacks/${encodeURIComponent(String(feedback))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
